"use strict";
var wellKnownSymbol = require("../internals/well-known-symbol");
var create = require("../internals/object-create");
var defineProperty = require("../internals/object-define-property").f;
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] === void 0) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}
module.exports = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
